import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function newInventoryCn(series, start, end) {
    const _json = { "series": series, "start": start, "end": end, "auth": getToken() };
    const res = await fetch(API_ENDPOINT + "inventory/cn/new", {
        method: "POST",
        body: JSON.stringify(_json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}